import { render, staticRenderFns } from "./FullOfferEvents.vue?vue&type=template&id=0386cac1&scoped=true"
import script from "./FullOfferEvents.vue?vue&type=script&lang=js"
export * from "./FullOfferEvents.vue?vue&type=script&lang=js"
import style0 from "./FullOfferEvents.vue?vue&type=style&index=0&id=0386cac1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0386cac1",
  null
  
)

export default component.exports